// 指令:原位置悬浮(fix)
// ==============================
import twui from '@/config/twui'

export default {
  name: 'fix',
  inserted: function (el, binding, vnode) {
    let offset = twui.offset(el)
    let fixTop = binding.value
    offset.origiLeft = el.style.left

    twui.fix = function () {
      let scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop
      let className = el.className

      if (scrollTop > fixTop) {
        if (className.indexOf(' xfix') !== -1) return
        el.className = className + ' xfix'
        el.style.left = offset.left + 'px'
      } else {
        if (className.indexOf(' xfix') === -1) return
        el.className = className.replace(' xfix', '')
        el.style.left = offset.origiLeft
      }
    }

    window.addEventListener('scroll', twui.fix, false)
  },
  unbind: function () {
    window.addEventListener('scroll', twui.fix, false)
  }
}



// WEBPACK FOOTER //
// ./src/directives/fix.js